export default __webpack_public_path__ + "static/media/NLR-2.33a27d7a.webp";